import PropTypes from 'prop-types';
import css from './gallery.module.scss';
import getGalleryItem from './utils/getGalleryItem';
import getNumberOfColumns from './utils/getNumberOfColumns';

const gridPctUnit = 100 / 6;
const showPeekTileWidthsBySlotCountMap = {
  1: 19,
  2: 32,
  3: 32,
};

export function CarouselItems({
  itemsMatrix,
  numRows,
  page,
  breakpoint,
  isExtendedInfoEnabled,
  showPeek,
  className = '',
}) {
  function renderGuideItem(guideItem, itemsArrayIndex, rowIndex) {
    const { Component: ItemComponent, requiredSlots } = getGalleryItem(guideItem);
    const itemIndex = Number.parseInt(guideItem?.index ?? itemsArrayIndex + 1, 10) - 1;
    const { tileSize } = guideItem.styles || {};
    const numberOfColumns = getNumberOfColumns(requiredSlots, breakpoint, tileSize);

    const tileWidthAsNumber = showPeek
      ? showPeekTileWidthsBySlotCountMap[requiredSlots]
      : gridPctUnit * numberOfColumns;
    const tileWidth = `${tileWidthAsNumber}%`; // as a %

    return (
      <div
        data-testid={`carouselGuideItem-${itemIndex}`}
        key={`row-${rowIndex}item-${itemIndex}id-${guideItem.guideId}`}
        className={css.item}
        style={{ width: tileWidth }}
        data-guideid={guideItem.guideId}
      >
        <ItemComponent
          guideItem={guideItem}
          index={itemIndex}
          isExtendedInfoEnabled={isExtendedInfoEnabled}
          containerClassName={css.carouselItemContainer}
        />
      </div>
    );
  }

  return (
    <div
      data-testid="carousel"
      className={`${className} ${css.carousel} ${numRows === 1 ? css.row : ''}`}
      style={{ left: `-${page * 100}%` }}
    >
      {itemsMatrix.map((items, rowIndex) =>
        numRows > 1 ? (
          <div key={`row-${rowIndex}`} className={`${css.row} ${css.carouselRow}`}>
            {items.map((guideItem, index) => renderGuideItem(guideItem, index, rowIndex))}
          </div>
        ) : (
          items.map((guideItem, index) => renderGuideItem(guideItem, index, rowIndex))
        ),
      )}
    </div>
  );
}

CarouselItems.propTypes = {
  page: PropTypes.number.isRequired,
  itemsMatrix: PropTypes.array.isRequired,
  numRows: PropTypes.number.isRequired,
  breakpoint: PropTypes.number.isRequired,
  isExtendedInfoEnabled: PropTypes.bool,
  showPeek: PropTypes.bool,
  className: PropTypes.string,
};
